import React from 'react';

import { Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import { useVehicle } from '../../context';

function Created({ isOpen, onClose }) {
  const vehicle = useVehicle();
  const navigate = useNavigate();

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        heading={
          <Text type="header" color="dark" weight="500">
            Cadastro de veículo
          </Text>
        }
        body={
          <Row className="mx-0 mt-1">
            <Text weight="400" color="dark">
              Veículo {vehicle.data.plate} cadastrado com sucesso!
            </Text>
          </Row>
        }
        footer={
          <div
            className="mr-3 mt-1"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              flexWrap: 'nowrap',
            }}
          >
            <Button
              variant="white"
              className="mt-1 py-2"
              outlined
              size="sm"
              style={{ minWidth: 160, width: 'auto' }}
              onClick={() => {
                onClose?.();
                navigate('/veiculos');
              }}
            >
              <Text weight="500" type="regular">
                Ver listagem
              </Text>
            </Button>

            <Button
              className="mt-1 py-2"
              variant="primary"
              size="sm"
              style={{ minWidth: 160, width: 'auto' }}
              onClick={() => {
                onClose?.();
                navigate(`/veiculos/${vehicle?.data?.id}`);
              }}
            >
              <Text weight="500" type="regular">
                Ver veículo
              </Text>
            </Button>

            <Button
              variant="success"
              className="mt-1 py-2"
              size="sm"
              style={{ minWidth: 160, width: 'auto' }}
              onClick={() => {
                onClose?.();
                window.location.reload(false);
              }}
            >
              <Text weight="500" type="regular">
                Novo veículo
              </Text>
            </Button>
          </div>
        }
      />
    </>
  );
}

export default Created;
